<template>
    <Breadcrumbs main="Bonus Ui" title="Tree View" />
    <div class="container-fluid">
        <div class="row">
            <basicTree />
            <checkTree />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const basicTree = defineAsyncComponent(() => import("@/components/theme/advance/tree/basicTree.vue"))
const checkTree = defineAsyncComponent(() => import("@/components/theme/advance/tree/checkTree.vue"))
</script>